// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.portal-links-container {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 3px;\n}\n.portal-link {\n  display: grid;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  padding: 4px;\n  height: 100%;\n}\n.portal-link-content {\n  display: grid;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  max-height: 53px;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
